import { Flex, HStack, Text, VStack, Image, Icon, Link } from "@chakra-ui/react";
import React from "react";
import eximpeLogo from "../assets/eximpe_logo_black.png";
import demoLogo from '../assets/demo_logo.svg'

import { AiFillCheckCircle } from 'react-icons/ai'

const RequestDemoSideContent = () => {
  return (

    <Flex w="30%" direction="column" mr={10}
    >
      <Link href="https://www.eximpe.com/" left={0}>
        <Image
          w="125px"
          h="33px"
          src={eximpeLogo}
          position="absolute"
          top="30px"
        />
      </Link>
      <Image w="125px" h="125px" src={demoLogo} />
      <Flex direction="column" mt={6}>
        <Text fontWeight="bold" fontSize="4xl">Request a Demo</Text>
        <Text fontWeight="medium" fontSize="18px" color="#718096">Fill out the form and we will get in touch with you shortly</Text>
      </Flex>
      <VStack alignItems="flex-start" mt={10} spacing={6}>
        <HStack spacing={4}>
          <Icon as={AiFillCheckCircle} boxSize="28px" color="#26A887" />
          <Text fontWeight="normal" fontSize="16px">Save up to 70% on FX Margins today</Text>
        </HStack>
        <HStack spacing={4}>
          <Icon as={AiFillCheckCircle} boxSize="28px" color="#26A887" />
          <Text fontWeight="normal" fontSize="16px">Multi currency Virtual Accounts and Zero Balance Global Trade account</Text>
        </HStack>
        <HStack spacing={4}>
          <Icon as={AiFillCheckCircle} boxSize="28px" color="#26A887" />
          <Text fontWeight="normal" fontSize="16px">Powered by AD1 Banks, Fully compliant with RBI Regulations</Text>
        </HStack>
      </VStack>
    </Flex>
  );
};

export default RequestDemoSideContent;
